import React from 'react'
import Game from './Game'
import { render, getConfig, initErrorMonitoring } from '@educaplay/core'
import { assetsUrl, GameProvider } from '@educaplay/core'
import { initialize } from '@educaplay/store'
import classes from './Game.module.scss'
import { createCustomization } from '@educaplay/core/utils/customization'

initErrorMonitoring("https://99be1ae05c29d3be4b2546e5f39431d4@o4509038211104768.ingest.de.sentry.io/4509077427257424");

const gameImage = assetsUrl("DIALOGO/logoActivity.webp");
const container = document.getElementById('root');

const isValidAuthor = (author) => author.name || author.avatar;
const isValidContent = (content) => content.text || content.media;

async function init() {
  const { data, texts, settings, user, title, description, author, id, url } = await getConfig().catch((err) =>
    console.error('Error al obtener la configuración: ', err)
  )

  const { ACTORES, TEXTOS } = data;

  const authors = ACTORES.map(actor => ({
    id: actor.UID,
    name: actor.NOMBRE,
    avatar: actor.MULTIMEDIA ? `${settings.resources}${actor.MULTIMEDIA}` : null
  }))

  const sequences = TEXTOS.map((sequence, index) => ({
    id: `sequence-${index}`,
    text: sequence.ENUNCIADO,
    author: authors.find(actor => actor.id === sequence.ACTOR),
    media: sequence.MULTIMEDIA ? {
      type: sequence.MULTIMEDIA_TIPO,
      src: `${settings.resources}${sequence.MULTIMEDIA}`
    } : null
  }))

  const secuencesFiltered = sequences.filter(sequence => isValidAuthor(sequence.author) && isValidContent(sequence));
  const secuencesFormatted = secuencesFiltered.map(sequence => ({
    ...sequence,
    text: sequence.text || "...",
  }))

  const dialog = {
    id: "dialog",
    bank: null,
    checkAnswer: () => true,
    answer: null,
    points: 100,
    media: null,
    dialog: {
      sequences: secuencesFormatted
    }
  }

  initialize({
    lives: data.NUMERO_INTENTOS, //COMPROBAR SI ES MAXIMO
    liveActived: !!data.NUMERO_INTENTOS_INFINITOS && data.NUMERO_INTENTOS_INFINITOS !== "si",
    hasCountDown: data.TIEMPO_INFINITO === "no",
    randomized: data.ALEATORIO === "si",
    showSolutions: false,
    showRestart: data.OCULTAR_REINICIAR !== "1",
    showSocialMedia: data.OCULTAR_REDES !== "1",
    finalText: data.TEXTO_FINAL,
    hasBank: false,
    questions: [dialog],
    settings,
    title,
    description,
    author,
    id,
    url,
    user,
    showButtonReports: false,
    customizations: createCustomization(data),
    countFooterSpace: true,
  });

  render(container, (
    <React.StrictMode>
      <GameProvider
        gameImage={gameImage}
        texts={texts}
        Game={Game}
        classes={{
          layout: classes.layout,
        }}
        mappers={{
          report: () => { }
        }}
      />
    </React.StrictMode>
  ))
}

init();